import OrderDetails from "./OrderDetails";
import OrderReceipts from "./OrderReceipts";

const ViewLayout = {
    Main: OrderDetails,
    Receipts: OrderReceipts
}

export default ViewLayout;